<app-grid
  *ngIf="(gridColumns$ | async) && (gridOptions$ | async)"
  [data]="gridData"
  [columns]="gridColumns$ | async"
  [options]="gridOptions$ | async"
></app-grid>

<ng-template #timeComponent let-context>
  <app-time [time]="context.selectedTime" (timeChanged)="context.timeChanged($event)"></app-time>
</ng-template>
